import { useState, useMemo } from 'react';
import { Collaborator } from '@/models';
import { AdvancedFilterValues } from '@/features/Collaborators/List/Filters/AdvancedFiltersModal';
import { normalizeString } from '@/utils/stringUtils';

const initialAdvancedFilters: AdvancedFilterValues = {
    contractTypes: [],
    performanceFilter: null,
    seniorityId: '',
    resourceTypeId: '',
    technologyId: '',
};

export const useCollaboratorFilter = (collaborators: Collaborator[]) => {
    const [nameSearchQuery, setNameSearchQuery] = useState('');
    const [advancedFilters, setAdvancedFilters] = useState<AdvancedFilterValues>(initialAdvancedFilters);

    const filteredCollaborators = useMemo(() => {
        let filteredItems = [...collaborators];

        // Filtro por nome será feito pela TanStack Table via column filter

        if (advancedFilters.contractTypes && advancedFilters.contractTypes.length > 0) {
            filteredItems = filteredItems.filter(c =>
                !!c.collaboratorType && advancedFilters.contractTypes.includes(c.collaboratorType)
            );
        }

        // Performance filter - temporarily disabled
        if (advancedFilters.performanceFilter) {
            // Rating moved to sensitive data - temporarily disable performance filtering
            console.warn('Performance filtering temporarily disabled - will be restored in Phase 4');
        }

        if (advancedFilters.resourceTypeId) {
            filteredItems = filteredItems.filter(c =>
                c.resources?.some(r => r.typeId === advancedFilters.resourceTypeId)
            );
        }

        if (advancedFilters.technologyId) {
            filteredItems = filteredItems.filter(c =>
                c.resources?.some(r => r.technologyId === advancedFilters.technologyId)
            );
        }

        if (advancedFilters.seniorityId) {
            filteredItems = filteredItems.filter(c =>
                c.resources?.some(r => r.seniorityId === advancedFilters.seniorityId)
            );
        }

        return filteredItems;
    }, [collaborators, nameSearchQuery, advancedFilters]);

    const clearAdvancedFilters = () => {
        setAdvancedFilters(initialAdvancedFilters);
    };

    return {
        filteredCollaborators,
        nameSearchQuery,
        setNameSearchQuery,
        advancedFilters,
        setAdvancedFilters,
        clearAdvancedFilters
    };
}; 